const footerLinks = {
  剧集分类: ['国产剧', '港剧', '台剧', '韩剧', '日剧', '美剧', '古装剧', '悬疑剧', '都市剧'],
  热门推荐: ['狂飙', '繁花', '庆余年第二季', '长安十二时辰', '三体', '漫长的季节', '藏海花'],
  帮助中心: ['常见问题', '播放帮助', '画质说明', '设备支持', '意见反馈', '版权声明'],
  关于我们: ['平台介绍', '商务合作', '加入我们', '用户协议', '隐私政策'],
};

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-5 gap-8 md:gap-12">
            <div className="col-span-2 md:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-movie-2-line text-white text-lg"></i>
                </div>
                <span className="font-heading text-lg font-bold text-background-50">
                  天美影视
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                天美影视电视剧大全，最新电视剧全集高清免费在线观看。不缓冲流畅追剧，海量电视剧资源每日更新，为您带来极致观影体验。
              </p>
            </div>

            {Object.entries(footerLinks).map(([title, links]) => (
              <div key={title}>
                <h4 className="text-sm font-semibold text-background-100 mb-4 font-heading">
                  {title}
                </h4>
                <ul className="flex flex-col gap-2.5">
                  {links.map((link) => (
                    <li key={link}>
                      <a
                        href={`#${link}`}
                        className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                        onClick={(e) => e.preventDefault()}
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-background-700/50">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-3 mb-6">
              <span className="text-sm text-background-400 font-medium">合作伙伴：</span>
              <div className="flex flex-wrap gap-4">
                {['合作平台A', '合作平台B', '合作平台C', '合作平台D', '合作平台E'].map((p) => (
                  <span key={p} className="text-sm text-background-500">
                    {p}
                  </span>
                ))}
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
              <p className="text-xs text-background-500">
                &copy; 2026 天美影视 版权所有 | 本站内容仅供学习交流，请于下载后24小时内删除
              </p>
              <div className="flex items-center gap-4">
                <a href="#" className="text-background-500 hover:text-primary-400 transition-colors text-sm">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="text-background-500 hover:text-primary-400 transition-colors text-sm">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="text-background-500 hover:text-primary-400 transition-colors text-sm">
                  <i className="ri-bilibili-line"></i>
                </a>
                <a href="#" className="text-background-500 hover:text-primary-400 transition-colors text-sm">
                  <i className="ri-tiktok-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}